var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.2388 45.2383C50.0961 44.1668 51.2404 42.1855 51.2404 40.0413V17.9587C51.2404 15.8145 50.0961 13.8332 48.2388 12.7617L29.1187 1.73002C27.263 0.659386 24.9773 0.659384 23.1217 1.73002L4.00151 12.7617C2.14425 13.8332 1 15.8145 1 17.9587V40.0413C1 42.1855 2.14425 44.1668 4.00151 45.2383L23.1217 56.27C24.9773 57.3406 27.263 57.3406 29.1187 56.27L48.2388 45.2383Z",
    fill: "url(#paint0_radial_18355_93817)",
    stroke: "url(#paint1_linear_18355_93817)",
    strokeWidth: 1.29612
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5383 42.8635H14.7258C13.0984 42.8635 11.7656 41.5588 11.7656 39.9595V19.1402C11.7656 15.4645 14.5013 13.7951 17.8543 15.4365L24.0832 18.4948C25.43 19.1542 26.5383 20.9079 26.5383 22.395V42.8635Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8208 33.1267V38.4297C39.8208 41.46 38.4179 42.863 35.3876 42.863H26.5352V26.6172L27.1945 26.7575L33.5077 28.1744L36.3556 28.8057C38.2074 29.2126 39.7226 30.1666 39.8067 32.8602C39.8208 32.9443 39.8208 33.0285 39.8208 33.1267Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 24.625H21.583",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 30.2344H21.583",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5084 28.1748V32.6921C33.5084 34.4318 32.0915 35.8487 30.3519 35.8487C28.6123 35.8487 27.1953 34.4318 27.1953 32.6921V26.7578L33.5084 28.1748Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8069 32.8576C39.7227 34.5131 38.3479 35.8458 36.6644 35.8458C34.9248 35.8458 33.5078 34.4289 33.5078 32.6893V28.1719L36.3557 28.8032C38.2076 29.21 39.7227 30.164 39.8069 32.8576Z",
    stroke: "#EEEEEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18355_93817",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1202 29) rotate(90) scale(57.5167 49.8217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121212"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18355_93817",
    x1: 4.99639,
    y1: 2.41667,
    x2: 41.5768,
    y2: 63.7624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289672,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696447,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.365b8182fcc12eb3941268b5e288fb6d.svg";
export { ForwardRef as ReactComponent };